import {
    MAIN_LAYOUT,
    MAIN_LAYOUT_CHECK,
    MAIN_LAYOUT_FAIL,
    MAIN_LAYOUT_NO_PERMISSION,
    MAIN_LAYOUT_NOT_CHOOSE_CORP,
    MAIN_LAYOUT_NOT_SIGN_IN,
    MAIN_LAYOUT_RESET,
    MAIN_LAYOUT_SET_PARAMS, 
    MAIN_LAYOUT_SET_PERMISSIONS,
    MAIN_LAYOUT_SUCCESS,
} from './constants';

export const layoutMainReset = () => ({
    type: MAIN_LAYOUT_RESET,
    payload: null,
});

export const layoutMainSetParams = ({params}) => ({
    type: MAIN_LAYOUT_SET_PARAMS,
    payload: {params},
});

export const layoutMainSetPermissions= ({permissions}) => ({
    type: MAIN_LAYOUT_SET_PERMISSIONS,
    payload: {permissions},
});

export const layoutMain = ({params}) => ({
    type: MAIN_LAYOUT,
    payload: {params},
});

export const layoutMainSuccess = (data) => ({
    type: MAIN_LAYOUT_SUCCESS,
    payload: data,
});

export const layoutMainFail = (data) => ({
    type: MAIN_LAYOUT_FAIL,
    payload: data,
});

export const layoutMainSignCheck = ({errors, errorCode, message, showToast}) => ({
    type: MAIN_LAYOUT_CHECK,
    payload: {errors, errorCode, message, showToast},
});

export const layoutMainNotSignIn = () => ({
    type: MAIN_LAYOUT_NOT_SIGN_IN,
    payload: null,
});

export const layoutMainNotChooseCorp = () => ({
    type: MAIN_LAYOUT_NOT_CHOOSE_CORP,
    payload: null,
});

export const layoutMainNoPermission = () => ({
    type: MAIN_LAYOUT_NO_PERMISSION,
    payload: null,
});


